import * as React from "react";
import { useSandpack } from "./useSandpack";
export var useErrorMessage = function useErrorMessage() {
  var _a;

  var _useSandpack = useSandpack(),
      sandpack = _useSandpack.sandpack;

  var error = sandpack.error;
  React.useEffect(function () {
    sandpack.errorScreenRegisteredRef.current = true;
  }, []);
  return (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : null;
};